import { Col, Flex, Row, Space } from 'antd';
import Sider from 'antd/es/layout/Sider';
import React from 'react';
import pskagallogo from "../../assets/images/website/logo.jpg";
import dgiprlogo from "../../assets/images/website/dgipr-logo.png";
import psaadhar from "../../assets/images/website/footer//ps-aadhar.jpg";
import psaaplesarkar from "../../assets/images/website/footer/ps-aaple-sarkar.jpg";
import psAdhikar from "../../assets/images/website/footer/ps-Adhikar.jpg";
import pssewa from "../../assets/images/website/footer/ps-sewa.jpg";

const HomeFooter = ({ isTabletOrMobile }) => {
    return (
        <div className='footer'>
            <div className="footer-logos">
                <Row justify={isTabletOrMobile ? "space-between" : 'space-evenly'}>
                    <a target='_blank' href='https://rtionline.maharashtra.gov.in/'><img style={{ height: 65 }} src={psAdhikar} /></a>
                    <a target='_blank' href='https://aaplesarkar.maharashtra.gov.in/en/'><img style={{ height: 65 }} src={psaaplesarkar} /></a>
                    <a target='_blank' href='https://www.mahaonline.gov.in/'><img style={{ height: 65 }} src={pssewa} /></a>
                    <a target='_blank' href='https://uidai.gov.in/'><img style={{ height: 65 }} src={psaadhar} /></a>
                </Row>
            </div>

            <Row style={{ paddingTop: 25 }}>
                <Col xl={4} lg={4} md={0} sm={0} xs={0}></Col>
                <Col span={16} style={{ alignItems: "center" }}>
                    <Row>
                        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                            <ul>
                                <li><a href='/'>मुख्यपृष्ठ  </a> </li>
                                <li><a href='/padadhikari'>पदाधिकारी  </a> </li>
                                <li><a href='/officers'>अधिकारी    </a> </li>
                                <li><a href='/photo-gallery'>छायाचित्रे   </a> </li>
                                <li><a href='/contact'>संपर्क    </a> </li>
                            </ul>
                        </Col>
                        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                            <ul>
                                <li><a href='/photo-gallery'>फोटो
                                    गॅलरी</a></li>
                                <li><a href='/video-gallery'>विडियो
                                    गॅलरी</a></li>
                                <li><a href='/public-grievance'>तक्रार निवारण</a></li>
                            </ul>
                        </Col>
                        <Col xl={6} lg={6} md={12} sm={24} xs={24} style={{ paddingLeft: isTabletOrMobile && 30 }}>
                            <p>पंचायत समिती कागल<br />
                                गट विकास अधिकारी<br />
                                पंचायत समिती, कागल<br />
                                फोन नं : 02325-244022 <br />
                                ई - मेल : bdokagal123@gmail.com</p>
                        </Col>
                    </Row>
                </Col>
                <Col xl={4} lg={4} md={0} sm={0} xs={0}></Col>
            </Row>
            <Row>
                <Col span={24} style={{ textAlign: "center" }}>
                    <div>
                        Powered By <a target='_blank' href='https://webthoughts.in' style={{ textDecoration: "underline", fontWeight: "bold" }}>WebThoughts Technologies</a>
                    </div>
                    <div style={{ textAlign: "center" }}>Copyright © 2026   पंचायत समिती, कागल</div>
                </Col>
            </Row>
        </div>
    );
}

export default HomeFooter;